import { makeStyles } from '@material-ui/core';

export const vendaFormStyles = makeStyles({
  divider: {
    backgroundColor: 'rgba(0, 0, 0, 0.50)',
    marginBottom: 16,
    marginTop: 16,
  },
  valorTotal: {
    width: '100%',
    marginTop: 8,
    '& > label': {
      marginBottom: 8,
      fontSize: 24,
      fontWeight: 500,
      color: '#111',
    },
  },
  buttonSave: {
    border: '1px solid #43a047',
    color: '#43a047',
    width: 90,
    height: 36,
    marginLeft: 10,
    borderRadius: 5,
    backgroundColor: '#eee',
    textTransform: 'capitalize',
    '&:hover': {
      background: '#43a047',
      color: 'white',
    },
  },
  buttonSalvarEnviar: {
    background: '#43a047',
    color: '#fff',
    width: 130,
    height: 36,
    marginLeft: 10,
    borderRadius: 5,
    textTransform: 'initial',
    transition: '0.4s',
    '&:hover': {
      background: '#0f7047',
    },
  },
  label: {
    fontSize: '15px',
    color: 'black',
    marginRight: '5px',
    fontWeight: '500',
  },
});
